import * as React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { actionCreators } from './actions';
import { CaseDraftInfoState } from './types';
import { MdArrowForwardIos, MdArrowRightAlt, MdOutlineDescription } from 'react-icons/md';
import { getExpirationDate } from 'app/area/shared/case-draft-info-panel/get-expiration-date';
import styles from './case-draft-info-panel.scss';

export interface CaseDraftInfoPanelOwnProps {
  textTitle?: string;
  textViewAll: string;
  textContinue: string;
  textExpires: string;
}

type CaseDraftInfoPanelProps = CaseDraftInfoState & CaseDraftInfoPanelOwnProps & typeof actionCreators;

const CaseDraftInfoPanelComponent: React.FC<CaseDraftInfoPanelProps> & { statePath?: string } = ({
  textTitle,
  textContinue,
  textExpires,
  textViewAll,
  count,
  data,
  fetching,
  loadDraftsData
}) => {
  useEffect(() => {
    loadDraftsData();
  }, []);

  if (fetching || !count) {
    return null;
  }

  return <div className={styles.caseDraft}>
    <div className={`row ${styles.panelRow}`}>
      <div className={`col-12 ${styles.panelBody}`}>
        <div>
          <div className={styles.panelHeader}>
            <MdOutlineDescription className={styles.panelIcon} />
            <div className={styles.panelHeaderText}>
              <label className="mb-0">{textTitle}</label>
              <div className={styles.draftCount}>{count}</div>
            </div>
          </div>
          <div className={styles.draftList}>
            {data?.slice(-4).map((item) => (
              <Link key={item.draftId} to={routeConstants.draftViewFor(item.draftId)} className={styles.draftItem}>
                <div className={styles.itemHeader}>
                  <MdOutlineDescription className={styles.itemIcon} />
                  <div className={styles.itemHeaderText}>
                    <h3 className={styles.itemTitle}>{item.caseTitle}</h3>
                    <div>
                      <div className={styles.itemMeta}>{item.caseType}</div>
                      {!!getExpirationDate(item.lockedDate) &&
                        <div className={styles.expiryText}>
                          {replaceTemplateString(textExpires, getExpirationDate(item.lockedDate))}
                        </div>}
                    </div>
                  </div>
                </div>
                <span className={styles.continueLink}>
                  {textContinue} <MdArrowForwardIos className={styles.linkIcon} />
                </span>
              </Link>
            ))}
          </div>
          <div className={styles.footer}>
            <Link to={routeConstants.myCaseDraftsView} className={styles.viewAllLink}>
              {textViewAll} <MdArrowRightAlt className={styles.viewAllLinkIcon} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

CaseDraftInfoPanelComponent.statePath = STATE.caseDraftInfo;

export const CaseDraftInfoPanel = containerFactory<CaseDraftInfoPanelOwnProps>(
  CaseDraftInfoPanelComponent,
  actionCreators,
  null,
  null
);
